import { TextField, useTheme } from "@mui/material";
import { borderRadius } from "@mui/system";
import { useState } from "react";

type Props = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  onBlur: (value: number) => void;
  disabled?: boolean;
};

const Q3DInputNumber = (props: Props) => {
  const theme = useTheme();
  const [isFixed, setIsFixed] = useState<boolean>(true);
  return (
    <TextField
      sx={{
        "& .MuiInputBase-input": {
          padding: "8px 10px 8px 10px",
          height: "20px",
          width: "80px",
        },
        color: theme.palette.base.contrast,
        ".MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.base.border,
        },
      }}
      label={props.label}
      type="number"
      inputProps={{ step: 0.5, min: 1, max: 10 }}
      InputProps={{ sx: { borderRadius: "0px" } }}
      InputLabelProps={{
        shrink: true,
      }}
      value={isFixed ? props.value?.toFixed(1) : props.value}
      onChange={(e) => {
        setIsFixed(false);
        const value = (e.target as HTMLInputElement).value;
        props.onChange(value ? Number(value) : null);
      }}
      onBlur={(e) => {
        setIsFixed(true);
        props.onBlur(Number((e.target as HTMLInputElement).value));
      }}
      disabled={props.disabled}
    />
  );
};

export default Q3DInputNumber;
